import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'ap-button-icon-select',
    templateUrl: './button-icon-select.component.html',
    styleUrls: ['./button-icon-select.component.css'],
    standalone: false
})
export class ButtonIconSelectComponent implements OnInit {
  @Input() isSelect = false;
  @Input() index: number;
  @Input() icon: string;

  @Output() select: EventEmitter<number> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {
  }

  selectButton(index: number) {
    return this.select.emit(index);
  }

  getIconCssAttribute() {
    const active = this.isSelect ? ' icon-active': '';
    let iconClass = '';
    switch (this.icon) {
      case 'eye':
        iconClass = 'fa-eye';
        break;
      case 'check':
        iconClass = 'fa-check';
        break;
      case 'close':
        iconClass = 'fa-close';
        break;
      default:
        iconClass = '';
    }

    return iconClass + active;
  }

  getColorButtonSelectedCssAttribute() {
    return this.isSelect ? 'button-selected-' + this.icon : '';
  }
}
